import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function LoginForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "email",
            placeholder: "E-mail address",
            type: "email",
            size: "medium",
            required: true,
            startIcon: "EmailOutlined",
          },
          {
            name: "password",
            placeholder: "Password",
            size: "medium",
            type: "password",
            required: true,
            startIcon: "LockOutlined",
          },
        ]}
        fullWidth={true}
        direction="column"
        spacing={2}
      />
    </div>
  );
});
